/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL 😉",
  'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
  'embedded.confluence.already-logged-in-paragraph': "Hai già effettuato l'accesso? Prova ad aggiornare la pagina.",
  'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
  'embedded.confluence.footer.prefix': 'Offerto da',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
  'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
  'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
  'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
  'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
  'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
  'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
  'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};